import React from 'react'
import MyNavbar from '../../../components/user/general/mynavbar/MyNavbar';
import Footer from '../../../components/user/general/footer/Footer';
import ShopBanner from '../../../subscreens/users/shop/shopBanner/ShopBanner'
import ShopsList from '../../../subscreens/users/shop/shopslist/ShopsList';
const ShopPage = () => {
  return (
    <>
    <MyNavbar />
    <ShopBanner />
    <ShopsList />
    <Footer />
    </>


  );

}
export default ShopPage;